import React, { Suspense, lazy } from "react";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import LoadingIndicator from "./components/LoadingIndicator";

const PdDetailsCoursePage = lazy(
    () => import("./components/pdSearch/PdDetailsCoursePage")
);

const globalAny: any = global;
globalAny.PdDetailsCoursePage = (props: any) => (
    <Provider store={store}>
        <Suspense fallback={<LoadingIndicator />}>
            <PdDetailsCoursePage {...props} />
        </Suspense>
    </Provider>
);
